import React, { useState } from "react";
import { onMessageListener } from "./firebaseMessage";
import Collapse from "react-bootstrap/Collapse";

function Notification() {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });


  onMessageListener()
    .then((payload) => {
      setShow(true);
      setNotification({
        title: payload.notification.title,
        body: payload.notification.body,
      });
      console.log(payload);
    })
    .catch((err) => console.log("failed: ", err));

  return (
    <div className="App">
        <Collapse in={show}>
            <div className="toast-container-custom">
                <div className="position-relative">
                    <p className="title">{notification.title}</p>
                    <p className="body">{notification.body}</p> 
                    <img src="/assets/img/exit.png" alt='close' className="close-noti" onClick={() => setShow(false)}/>
                </div>
            </div>
        </Collapse>
    </div>
  );
}

export default Notification;
